import { defineMessages } from 'react-intl';

export const bypassZeroResultsPageMessages = defineMessages({
  topCategories: {
    id: 'zeroResultsPage.topCategories.bypass.headline',
    defaultMessage: 'Top-Kategorien überspringen',
  },
});
